module.exports = {
  context: {
    email: {
      label: 'Email',
      placeholder: 'Email'
    },
    firstName: {
      label: 'First Name',
      placeholder: 'First Name'
    },
    lastName: {
      label: 'Last Name',
      placeholder: 'Last Name'
    },
    org: {
      label: 'Organization',
      placeholder: 'Organization'
    },
    message: {
      label: 'Message',
      placeholder: 'Message'
    }
  }
}
